import { VuetifyTiptap, VuetifyViewer, createVuetifyProTipTap } from 'vuetify-pro-tiptap';
import 'vuetify-pro-tiptap/style.css';

const vuetifyProTipTap = createVuetifyProTipTap({
    lang: localStorage.getItem('locale') || 'en',
    markdownTheme: 'github',
    components: {
        VuetifyTiptap,
        VuetifyViewer,
    },
});

export { vuetifyProTipTap };
